import {NgModule} from "@angular/core";

import {ComponentsModule} from "./components/components.module";
import {TranslocoDirective, TranslocoPipe} from "@jsverse/transloco";
import {TabsComponent} from "./components/tabs/tabs.component";
import {TabComponent} from "./components/tab/tab.component";
import {AsyncPipe, NgClass, NgForOf, NgIf, NgOptimizedImage, NgStyle} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {RouterLink} from "@angular/router";
import {StudentHeaderComponent} from "./components/header/student-header/student-header.component";
import {SemiHeaderComponent} from "./components/semi-header/semi-header.component";
import {NextLessonComponent} from "./components/lesson/next-lesson/next-lesson.component";
import {InfoComponent} from "./components/group/info/info.component";
import {RoundProgressComponent} from "angular-svg-round-progressbar";
import {CertificateComponent} from "./components/certificate/certificate.component";
import {CalendarComponent} from "./components/calendar/calendar.component";
import {ChangedCabinetComponent} from "./components/modals/changed-cabinet/changed-cabinet.component";
import {ViewTestComponent} from "./components/modals/view-test/view-test.component";
import {PracticingComponent} from "./components/modals/chose-group/practicing/practicing.component";
import {BirthdayCardComponent} from "./components/modals/birthday-card/birthday-card.component";
import {InfoComponentModal} from "./components/modals/info/info.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TransferLessonsComponent} from "./components/modals/transfer-lessons/transfer-lessons.component";
import {ReportAbsenceComponent} from "./components/modals/report-absence/report-absence.component";
import {FeedbackComponent} from "./components/feedback/feedback.component";
import {EducationalFileComponent} from "./components/modals/educational-file/educational-file.component";
import {DummyComponent} from "./components/dummy/dummy.component";
import {NewExamComponent} from "./components/modals/new-exam/new-exam.component";
import {AppUpdatesComponent} from "./components/modals/app-updates/app-updates.component";
import {LessonMaterialsComponent} from "./components/lesson/lesson-materials/lesson-materials.component";
import {PushMessageComponentModal} from "./components/modals/push-message/push-message.component";



@NgModule({
    imports: [
        ComponentsModule,
        TranslocoDirective,
        TranslocoPipe,
        NgForOf,
        NgIf,
        NgClass,
        IonicModule,
        RouterLink,
        RoundProgressComponent,
        AsyncPipe,
        NgOptimizedImage,
        ReactiveFormsModule,
        FormsModule,
        NgStyle,
    ],
    exports: [
        ComponentsModule,
        TranslocoDirective,
        TranslocoPipe,
        TabsComponent,
        TabComponent,
        StudentHeaderComponent,
        SemiHeaderComponent,
        NextLessonComponent,
        CertificateComponent,
        CalendarComponent,
        InfoComponent,
        ChangedCabinetComponent,
        ViewTestComponent,
        PracticingComponent,
        BirthdayCardComponent,
        InfoComponentModal,
        PushMessageComponentModal,
        TransferLessonsComponent,
        ReportAbsenceComponent,
        FeedbackComponent,
        EducationalFileComponent,
        DummyComponent,
        NewExamComponent,
        AppUpdatesComponent,
        LessonMaterialsComponent
    ],
    declarations: [
        TabsComponent,
        TabComponent,
        StudentHeaderComponent,
        SemiHeaderComponent,
        NextLessonComponent,
        InfoComponent,
        CertificateComponent,
        CalendarComponent,
        ChangedCabinetComponent,
        ViewTestComponent,
        PracticingComponent,
        BirthdayCardComponent,
        InfoComponentModal,
        PushMessageComponentModal,
        TransferLessonsComponent,
        ReportAbsenceComponent,
        FeedbackComponent,
        EducationalFileComponent,
        DummyComponent,
        NewExamComponent,
        AppUpdatesComponent,
        LessonMaterialsComponent
    ]
})
export class SharedModule {
}
